import axios from "./ServicesConfig";
const atendimentoService = {
  async salvarAtendimento(data) {
    return await axios.post("/atendimentos", data);
  },
};

export { atendimentoService };
